var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.78,
    y: 6.08,
    width: 20.88,
    height: 68.87,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.97,
    y: 6.08,
    width: 20.88,
    height: 68.87,
    fill: "currentColor"
  })));
};

export default SvgPauseIcon;